import axios from 'axios'
import { VueAxios } from './axios'
import { Dialog } from 'vant'
import storage from 'store'
import { ACCESS_TOKEN } from '@store/mutation-types.js'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 30000, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      Dialog({
        title: 'Forbidden',
        message: data.message,
      })
    }
    if (error.response.status === 500) {
      Dialog({
        title: '提示',
        message: data.message,
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      Dialog({
        title: 'Unauthorized',
        message: 'Authorization verification failed',
      })
      if (token) {
        storage.clear()
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['token'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  let data = response.data
  // if (data.code == 401) {
  //   Dialog({
  //     title: '提示',
  //     message: '您的登录已过期，请重新登录。',
  //   }).then(() => {
  //     setTimeout(() => {
  //       window.location.reload()
  //       storage.remove(ACCESS_TOKEN)
  //     }, 200)
  //   })
  // }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  },
}

export default request

export { installer as VueAxios, request as axios }
